import React from 'react';
import { Helmet } from 'react-helmet-async';
import { buildSoftwareApplicationSchema } from '../data/structuredData';

/**
 * SoftwareApplication JSON-LD in document head. Uses its own {@link Helmet} instance because
 * react-helmet-async does not allow custom components as children of {@link Helmet}—only intrinsic tags like &lt;script&gt;.
 *
 * @param {Parameters<buildSoftwareApplicationSchema>[0]} [overrides] - Top-level keys only; not a deep merge.
 */
export default function SoftwareApplicationJsonLd({ overrides } = {}) {
  const data = buildSoftwareApplicationSchema(overrides || {});
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}
